import axios from 'axios';
import { toast } from "react-toastify";

import { setupAjax } from './setup';
import exceptions from "../../exceptions";


class Ajax {
  constructor() {
    this.defaultOptions = {
      timeout: 600000,
      headers: {}
    };
    this.httpInstance = null;
    this.storageAdapter = null;
  }

  setStorageAdapter(adapter) {
    this.storageAdapter = adapter;
    return this;
  }
  getStorageAdapter() {
    return this.storageAdapter;
  }
  setMessageFormatter(formatMessage) {
    this.formatMessage = formatMessage;
    return this;
  }

  createHttpInstance(options) {
    this.httpInstance = axios.create({
      ...this.defaultOptions,
      ...options
    });
    const $this = this;
    this.httpInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      error => {
        if (error && error.message && error.message === 'Network Error') {
          toast.error(exceptions.network, { toastId: 'disconnected' })
        }
        if (error.response && error.response.data && error.response.data.code) {
          if (error.response.data.error.code === 6551) {
            toast.error(exceptions[error.response.data.error.message.toLowerCase().split(' ').join('-')], { toastId: `response-${error.response.data.error.code}` })
          } else if (exceptions[error.response.data.error.code]) {
            toast.error(exceptions[error.response.data.error.code], { toastId: `response-${error.response.data.error.code}` })
          }
          if (error.response.status === 401 && error.response.data.error.code === 4002) {
            $this.storageAdapter.remove('token');
            $this.storageAdapter.remove('user');
            setTimeout(() => {
              window.location.reload();
            }, 1000);
            const config = error.config;
            delete config.headers[config.tokenKey];
            // store.dispatch(setUserInfo(null));
            setupAjax();
          }
        }
        return Promise.reject(error.response || error);
      });
    return this;
  }

  sendOnRequests(propsArray) {
    // Uses a key-value pair.
    // key: the string as data is saved in storage
    // value: the string as data will be sent to server with that string as header
    propsArray.forEach(prop => {
      Object.keys(prop).forEach(key => {
        const propInStorage = this.storageAdapter.get(key);
        if (propInStorage) {
          this.httpInstance.defaults.headers.common[prop[key]] = propInStorage;
        } else {
          delete this.httpInstance.defaults.headers.common[prop[key]];
        }
      });
    });
    return this;
  }

  get(...params) {
    return this.httpInstance.get(...params);
  }
  post(...params) {
    return this.httpInstance.post(...params);
  }
  delete(...params) {
    return this.httpInstance.delete(...params);
  }
}

export const ajax = new Ajax();
